module.exports = __webpack_public_path__ + "img/boom1.6ffcdaef.png";